// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderExpandablePopover__container___mKRe4 {
    /* Базовая высота контента это базовая высота поповера без заголовка и двух оступов */
    --expandable-content-base-height: calc(
        var(--header-popover-base-height) - var(--header-title-height) - 2 * var(--space-s)
    );

    /* Расширенная высота контента это расширенная высота поповера без заголовка (вычисляется в js)  и двух оступов */
    --expandable-content-expanded-height: calc(
        var(--header-popover-expanded-height) - 2 * var(--space-s)
    );

    background-color: var(--color-bg-default);
    border-radius: var(--space-xs);

    & .HeaderExpandablePopover__body___FCQYT {
        display: flex;
        flex-direction: column;
    }

    &.HeaderExpandablePopover__left___jY60C,
    .HeaderExpandablePopover__center___wk5rE {
        right: unset;
        left: 0;
    }

    &.HeaderExpandablePopover__right___isOMi {
        right: 0;
        left: unset;
    }
}

.HeaderExpandablePopover__header___HEXO2 {
    display: flex;
    gap: var(--space-xs);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Header/HeaderExpandablePopover/HeaderExpandablePopover.css"],"names":[],"mappings":"AAAA;IACI,qFAAqF;IACrF;;KAEC;;IAED,iHAAiH;IACjH;;KAEC;;IAED,yCAAyC;IACzC,8BAA8B;;IAE9B;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;;QAEI,YAAY;QACZ,OAAO;IACX;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB","sourcesContent":[".container {\n    /* Базовая высота контента это базовая высота поповера без заголовка и двух оступов */\n    --expandable-content-base-height: calc(\n        var(--header-popover-base-height) - var(--header-title-height) - 2 * var(--space-s)\n    );\n\n    /* Расширенная высота контента это расширенная высота поповера без заголовка (вычисляется в js)  и двух оступов */\n    --expandable-content-expanded-height: calc(\n        var(--header-popover-expanded-height) - 2 * var(--space-s)\n    );\n\n    background-color: var(--color-bg-default);\n    border-radius: var(--space-xs);\n\n    & .body {\n        display: flex;\n        flex-direction: column;\n    }\n\n    &.left,\n    .center {\n        right: unset;\n        left: 0;\n    }\n\n    &.right {\n        right: 0;\n        left: unset;\n    }\n}\n\n.header {\n    display: flex;\n    gap: var(--space-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HeaderExpandablePopover__container___mKRe4`,
	"body": `HeaderExpandablePopover__body___FCQYT`,
	"left": `HeaderExpandablePopover__left___jY60C`,
	"center": `HeaderExpandablePopover__center___wk5rE`,
	"right": `HeaderExpandablePopover__right___isOMi`,
	"header": `HeaderExpandablePopover__header___HEXO2`
};
export default ___CSS_LOADER_EXPORT___;
